module.exports = __webpack_public_path__ + "static/media/exclamation.3f0ea419.svg";